module.exports = __webpack_public_path__ + "static/CVS-Catch-DLB-7-8-Core-V4.0-a8066e409a29b5a46566292cf5d09d09.pdf";